<template>
    <div>
        <div class="whiteBox">
            <div class="condition">
                <span>{{ $t('view.项目名称：') }}</span>
                <el-input v-model="form.sectionName" style="flex:1" size="mini"></el-input>
                <span style="margin-left: 20px;">{{ $t('view.招标单位：') }}</span>
                <el-input v-model="form.organization" style="flex:1" size="mini"></el-input>
                <span style="margin-left: 20px;">{{ $t('view.发布时间：') }}</span>
                <el-date-picker style="flex:1" size="mini" value-format="yyyy-MM-dd" v-model="TimeList" type="daterange" range-separator="-" :start-placeholder="$t('view.开始日期')" :end-placeholder="$t('view.结束日期')">
                </el-date-picker>
            </div>
            <div style="text-align: right;margin-top: 20px;">
                <el-button size="mini" type="primary" @click="form.pageNum=1; followSectionList()">{{ $t('view.搜索') }}</el-button>
                <el-button size="mini" style="margin: 0 10px;" @click="resetting">{{ $t('view.重置') }}</el-button>
            </div>
        </div>
        <div class="whiteBox">
            <div class="title" style="margin-bottom: 20px;">{{$t('view.我的关注')}}</div>
            <!-- 表格数据 -->
            <el-table header-row-class-name="tableHeader" :data="tableData" style="width: 1010px" border>
                <el-table-column type="index" width="60" align="center" :label="$t('view.序号')"></el-table-column>
                <el-table-column prop="sectionName" show-overflow-tooltip :label="$t('view.招标项目名称')">
                    <template slot-scope="scope">
                        {{ locale=='en'? scope.row.sectionNameEn:locale=='lo'?scope.row.sectionNameLo:scope.row.sectionName }}
                    </template>
                </el-table-column>
                <el-table-column prop="organization" align="center" show-overflow-tooltip :label="$t('view.招标单位')" ></el-table-column>
                <el-table-column prop="date" align="center" show-overflow-tooltip :label="$t('view.招标/询价')">
                    <template slot-scope="scope">
                        <span>{{scope.row.biddingType==1?$t('view.询价'):$t('view.招标')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="date" align="center" show-overflow-tooltip :label="$t('view.项目类型')" >
                    <template slot-scope="scope">
                        {{getStatus('sys_section_type',scope.row.projectType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="date" align="center" show-overflow-tooltip :label="$t('view.项目状态')" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.biddingType==1">{{ getStatus('sys_section_stauts',scope.row.sectionStauts) }}</span>
                        <span v-else>{{ getStatus('sys_section_stauts_tenders',scope.row.sectionStauts) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" align="center" width="150" show-overflow-tooltip :label="$t('view.发布时间')" ></el-table-column>
                <el-table-column prop="date" align="center" show-overflow-tooltip :label="$t('view.操作')" >
                    <template slot-scope="scope">
                        <span class="clickText" @click="TenderAnnouncement( scope.row.biddingType==1?'InquiryAnnouncement':'TenderAnnouncement', scope.row.sectionId)">{{ $t('view.详情') }}</span>
                        <span  style="margin-left: 10px;" @click="DelFollow(scope.row.id)" class="clickText">{{ $t('view.删除') }} </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;margin-top: 20px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
  </template>
    
<script>
import {followSectionList} from '@/api/PersonalCenter'
import {getDicts} from '@/api/index'
import {DelFollow} from '@/api/project'
  export default {
    data(){
        return{
            tableData:[],
            options:[],
            total:0,
            value:'',
            sys_section_stauts:[],
            sys_section_stauts_tenders:[],//
            sys_section_type:[],
            TimeList:[],
            locale: localStorage.getItem('locale')||'zh',
            form:{
                pageNum:1,
                organization:'',
                sectionName:'',
                pageSize:10
            }
        }
    },
    created(){
        this.getDicts('sys_section_type')//项目类型
        this.getDicts('sys_section_stauts')//项目状态
        this.getDicts('sys_section_stauts_tenders')//招标的项目状态
        this.followSectionList()
    },
    methods:{
        // 删除
        DelFollow(id){
            this.$confirm(this.$t('view.是否取消关注该项目'), this.$t('view.提示'), {
                confirmButtonText: this.$t('view.确定'),
                cancelButtonText: this.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                DelFollow(id).then(res=>{
                    if(res.code==200){
                        this.$message.success(this.$t('view.删除成功'))
                        this.followSectionList()
                    }
                })
            })
        },
        // 招标详情
        TenderAnnouncement(url,id){
            let routeUrl= this.$router.resolve({
                path: url,
                query: {id:id}
            })
            window.open(routeUrl.href, '_blank');
        },
        // 字典
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        // 重置
        resetting(){
            this.form={
                pageNum:1,
                organization:'',
                sectionName:'',
                pageSize:10
            }
            this.TimeList=[]
            this.followSectionList()
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.followSectionList()
        },
        followSectionList(){
            let createStartTime='params["createStartTime"]'
            let createEndTime='params["createEndTime"]'
            this.form[createStartTime] =(this.TimeList&&this.TimeList.length)?this.TimeList[0]:''
            this.form[createEndTime]=(this.TimeList&&this.TimeList.length)?this.TimeList[1]+" 23:59:59":''
            followSectionList(this.form).then(res=>{
                this.tableData=res.rows
                this.total=res.total
            })
        }
    }
};
</script>
<style lang="scss" scoped>
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
    .condition{
        display: flex;
        align-items: center;
    }
    .condition span{
        color: #333333;
        font-size: 14px;
    }
</style>
   